module.exports = __webpack_public_path__ + "img/worry-checkicon.f9d2b57.png";